import styled from 'styled-components';

import loginLandscape from '../../assets/media/login_landscape.svg';

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: #0a1628 url(${loginLandscape}) center center / cover no-repeat;

  /* Subtle darkening overlay for text legibility over the landscape */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(10, 22, 40, 0.25) 0%, rgba(10, 22, 40, 0.55) 100%);
    pointer-events: none;
  }
`;

/* Kept as no-op shims for backward compatibility with page imports */
export const ThirdOrb = styled.div`
  display: none;
`;

export const GridOverlay = styled.div`
  display: none;
`;

export const LanguagePickerWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 10;
`;

export const FormCard = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 40px 36px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 28px;

  img {
    height: 48px;
    width: auto;
    object-fit: contain;
  }
`;

export const FormTitle = styled.h2`
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: 22px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: #fff;
  text-align: center;
  margin-bottom: 6px;
`;

export const FormSubtitle = styled.p`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  margin-bottom: 28px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;

  /* Override TextInput styles for dark theme */
  input, textarea {
    background: rgba(255, 255, 255, 0.06) !important;
    border-color: rgba(255, 255, 255, 0.12) !important;
    color: #fff !important;

    &:focus {
      border-color: #0291EF !important;
      box-shadow: 0 0 0 3px rgba(2, 145, 239, 0.2) !important;
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.3) !important;
    }
  }

  /* Label above field — only target TextInput's floating label (inside InputContainer) */
  > div > div > label {
    position: static !important;
    transform: none !important;
    top: auto !important;
    left: auto !important;
    width: 100% !important;
    order: -1 !important;
    display: block !important;
    margin-bottom: 6px;
    padding: 0 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    color: rgba(255, 255, 255, 0.6) !important;
    background: transparent !important;
    pointer-events: auto;
  }

  /* InputContainer needs flex-wrap so label takes its own row */
  > div > div {
    flex-wrap: wrap;
  }

  /* Password toggle button — position relative to input, fix hover color for dark bg.
     Kurumsal giriş adımının düğmeleri (data-login-action) bu kuralın DIŞINDA: aksi hâlde yazıları soluklaşır. */
  button[type="button"]:not([data-login-action]) {
    top: auto;
    bottom: 13px;
    color: rgba(255, 255, 255, 0.4) !important;
    &:hover { color: rgba(255, 255, 255, 0.8) !important; }
  }
`;

export const RememberRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const RememberLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  flex-shrink: 0;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #0291EF;
    cursor: pointer;
    margin: 0;
  }
`;

export const ForgotLink = styled.div`
  flex-shrink: 0;
  white-space: nowrap;

  a {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
    transition: color 0.2s;

    &:hover {
      color: #0291EF;
    }
  }
`;

export const GradientButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(120deg, #0291EF 9.3%, #02D3BF 89.5%);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;

  &:hover:not(:disabled) {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// GradientButton'ın BAĞLANTI ikizi — başka bir adrese (ör. canlı panel) giden eylem: görünüm düğme,
// anlam bağlantı (adres görünür, yeni sekmede açılabilir). Kullanım: <GradientLinkButton as="a" href=…>.
export const GradientLinkButton = styled(GradientButton)`
  text-decoration: none;

  &:hover,
  &:visited {
    color: #fff;
  }
`;

export const SuccessMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: rgba(2, 211, 191, 0.12);
  border: 1px solid rgba(2, 211, 191, 0.2);
  border-radius: 6px;
  color: #02D3BF;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
`;

// Bilgi kutusu (ör. "hareketsizlik nedeniyle oturumunuz kapatıldı") — hata değil, bildirim.
export const InfoMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 18px;
  background: rgba(2, 145, 239, 0.12);
  border: 1px solid rgba(2, 145, 239, 0.25);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.85);
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  line-height: 1.45;

  svg { flex-shrink: 0; margin-top: 1px; color: ${({ theme }) => theme.colors.primary.main}; }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: rgba(229, 57, 53, 0.12);
  border: 1px solid rgba(229, 57, 53, 0.2);
  border-radius: 6px;
  color: #E53935;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
`;

// BackLink'in bağlantı yerine DÜĞME olan ikizi (aynı sayfada durum değiştiren "geri" eylemi).
// Form'un DIŞINDA durmalı: Form içindeki `button[type="button"]` kuralı şifre göz düğmesi içindir.
export const BackButton = styled.button`
  display: block;
  margin: 16px auto 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: rgba(255, 255, 255, 0.5);
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};

  &:hover {
    color: #0291EF;
  }
`;

export const BackLink = styled.div`
  text-align: center;
  margin-top: 16px;

  a {
    font-size: ${({ theme }) => theme.metrics.font.size.sm};
    color: rgba(255, 255, 255, 0.5);
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};

    &:hover {
      color: #0291EF;
    }
  }
`;

export const MascotLayer = styled.div`
  position: absolute;
  top: 0;
  right: 4px;
  width: 56px;
  height: 56px;
  z-index: 3;
  pointer-events: none;
  transition: transform 0.38s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

// Giriş formunun altındaki "İlk kez mi giriş yapıyorsunuz? Şifre Belirleyin" satırı — bağlantı vurgulu.
export const FirstLoginRow = styled.div`
  text-align: center;
  margin-top: 18px;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: rgba(255, 255, 255, 0.6);

  a {
    color: #0291EF;
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};

    &:hover {
      text-decoration: underline;
    }
  }
`;
